import React, { useEffect, useState } from 'react';
import Rating from './Rating';
import RatingTemp from './RatingTemp';
import { Link } from 'react-router-dom';
import RatingReact from 'react-rating';
import { FaStar } from 'react-icons/fa';
import { CiStar } from 'react-icons/ci';
import { useDispatch, useSelector } from 'react-redux';
import {
  customer_review,
  get_reviews,
  messageClear,
  product_details
} from '../store/reducers/homeReducer';
import toast from 'react-hot-toast';

const Reviews = ({ product, hideReviewForm = false, previewCount = 3 }) => {

  const dispatch = useDispatch();
  const [pageNumber] = useState(1);
  const [showAll, setShowAll] = useState(false);


  const { userInfo } = useSelector((state) => state.auth);
  const { successMessage, reviews = [], rating_review = [], totalReview = 0 } =
    useSelector((state) => state.home);

  const [rat, setRat] = useState('');
  const [re, setRe] = useState('');

  const visibleReviews = showAll ? reviews : reviews.slice(0, previewCount);
  const reviewTotal = totalReview || product?.reviews?.length || 0;


  const review_submit = (e) => {
    e.preventDefault();
    if (!rat) {
      toast.error('Please select a rating');
      return;
    }
    const obj = {
      name: userInfo.name,
      review: re,
      rating: rat,
      productId: product?._id
    };
    dispatch(customer_review(obj));
  };

  // refresh reviews after success
  useEffect(() => {
    if (successMessage && product?._id) {
      toast.success(successMessage);
      dispatch(
        get_reviews({
          productId: product._id,
          pageNumber
        })
      );
      dispatch(product_details(product.slug));
      setRat('');
      setRe('');
      dispatch(messageClear());
    }
  }, [successMessage, dispatch, product, pageNumber]);

  // initial fetch
  useEffect(() => {
    if (product?._id) {
      dispatch(
        get_reviews({
          productId: product._id,
          pageNumber
        })
      );
    }
  }, [dispatch, pageNumber, product]);

  // safely calculate rating bar width
  const getBarWidth = (index) => {
    const sum = rating_review?.[index]?.sum || 0;
    return totalReview ? Math.floor((100 * sum) / totalReview) : 0;
  };

  return (
    <div className={hideReviewForm ? '' : 'mt-8'}>
      {!hideReviewForm && (
      <div className="flex gap-10 md-lg:flex-col">
        {/* Rating Summary */}
        <div className="flex flex-col gap-2 justify-start items-start py-4">
          <div>
            <span className="text-6xl font-semibold">{product?.rating || 0}</span>
            <span className="text-3xl font-semibold text-slate-600">/5</span>
          </div>
          <div className="flex text-3xl">
            <Rating ratings={product?.rating || 0} />
          </div>
          <p className="text-sm text-slate-600">
            ({reviewTotal}) Reviews
          </p>
        </div>

        {/* Rating Breakdown */}
        <div className="flex gap-2 flex-col py-4">
          {[5, 4, 3, 2, 1].map((num, index) => (
            <div
              key={num}
              className="flex justify-start items-center gap-5"
            >
              <div className="text-md flex gap-1 w-[93px]">
                <RatingTemp rating={num} />
              </div>
              <div className="w-[200px] h-[14px] bg-slate-200 relative">
                <div
                  style={{ width: `${getBarWidth(5 - num)}%` }}
                  className="h-full bg-[#Edbb0E]"
                ></div>
              </div>
              <p className="text-sm text-slate-600 w-[0%]">
                {rating_review?.[5 - num]?.sum || 0}
              </p>
            </div>
          ))}
        </div>
      </div>
      )}

      {/* Product Reviews List */}
      {!hideReviewForm && (
        <h2 className="text-slate-600 text-xl font-bold py-5">
          Product Review ({reviewTotal})
        </h2>
      )}

      <div className={hideReviewForm ? 'grid gap-2 mds:grid-cols-2' : 'flex flex-col gap-8 pb-10 pt-4'}>
        {reviews?.length > 0 ? (
          visibleReviews.map((r, i) => (

            <div
              key={i}
              className={
                hideReviewForm
                  ? 'rounded-xl bg-slate-50 p-3 ring-1 ring-slate-100'
                  : 'flex flex-col gap-1'
              }
            >
              <div className="flex justify-between items-center gap-3">
                <div className={hideReviewForm ? 'flex gap-1 text-sm' : 'flex gap-1 text-xl'}>
                  <RatingTemp rating={r?.rating || 0} />
                </div>
                <span className={hideReviewForm ? 'shrink-0 text-[11px] text-slate-400' : 'text-slate-600'}>{r?.date || ''}</span>
              </div>
              <span className={hideReviewForm ? 'mt-2 block text-xs font-black text-slate-900' : 'text-slate-600 text-md'}>{r?.name || 'Anonymous'}</span>
              <p className={hideReviewForm ? 'mt-1 line-clamp-3 text-xs leading-5 text-slate-600' : 'text-slate-600 text-sm'}>{r?.review || ''}</p>
            </div>
          ))
        ) : (
          <p className="text-slate-500 italic">No reviews yet.</p>
        )}

        {/* Pagination */}
        {/* {totalReview > parPage && (
          <div className="flex justify-end">
            <Pagination
              pageNumber={pageNumber}
              setPageNumber={setPageNumber}
              totalItem={totalReview}
              parPage={parPage}
              showItem={Math.floor(totalReview / 3)}
            />
          </div>
        )} */}
        {!hideReviewForm && reviews.length > previewCount && !showAll && (
          <div className="text-center mt-4">
            <button
              onClick={() => setShowAll(true)}
              className="px-5 py-2 bg-[#059473] text-white rounded-md hover:shadow-md"
            >
              See More Reviews
            </button>
          </div>
        )}

      </div>

      {/* Review Form */}
      {!hideReviewForm && (
      <div>
        {userInfo ? (
          <div className="flex flex-col gap-3">
            <div className="flex gap-1">
              <RatingReact
                onChange={(e) => setRat(e)}
                initialRating={rat}
                emptySymbol={<span className="text-slate-600 text-4xl"><CiStar /></span>}
                fullSymbol={<span className="text-[#Edbb0E] text-4xl"><FaStar /></span>}
              />
            </div>
            <form onSubmit={review_submit}>
              <textarea
                value={re}
                onChange={(e) => setRe(e.target.value)}
                required
                className="border outline-0 p-3 w-full"
                cols="30"
                rows="5"
              ></textarea>
              <div className="mt-2">
                <button className="py-1 px-5 bg-indigo-500 text-white rounded-sm">
                  Submit
                </button>
              </div>
            </form>
          </div>
        ) : (
          <div>
            <Link
              to="/login"
              className="py-1 px-5 bg-red-500 text-white rounded-sm"
            >
              Login First
            </Link>
          </div>
        )}
      </div>
      )}
    </div>
  );
};

export default Reviews;
